import { Component, Input } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent {
  @Input() title: string;
  @Input() message: string;

  constructor(protected ref: NbDialogRef<ModalComponent>) { }

  cancel() {
    this.ref.close();
  }
  submit() {
    this.ref.close(true);
  }
}
